import React, { useState, useRef } from "react";
import config from '../config'; 

import Image from "./Image";

import "../styles/Gallery.css";

const Gallery = ({ images, mode, module, name, timestamp }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef(null);
  const touchDelta = useRef(null);
  const thumbnailsRef = useRef(null);
  const imgMainRef = useRef(null);
  const imgLeftRef = useRef(null);
  const imgCenterRef = useRef(null);
  const imgRightRef = useRef(null);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => {
      const newIndex = (prevIndex + 1) % images.length;
      scrollThumbnails(newIndex);
      return newIndex;
    });
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) => {
      const newIndex = prevIndex === 0 ? images.length - 1 : prevIndex - 1;
      scrollThumbnails(newIndex);
      return newIndex;
    });
  };

  const handleMouseStop = () => {
    handleMouseEnd(imgMainRef,imgLeftRef,imgCenterRef,imgRightRef);
    document.removeEventListener("mouseup", handleMouseStop);
  };

  const handleMouseStart = (event) => {
    const isTouch = event.type.startsWith("touch");
    const clientX = isTouch ? event.touches[0].clientX : event.clientX;
    touchStartX.current = clientX;
  
    if(isTouch===false) {
      document.addEventListener("mouseup", handleMouseStop);
    }
  };

  const handleMouseMove = (event,main,left,center,right) => {
    if (!touchStartX.current) return;

    const isTouch = event.type.startsWith("touch");
    const clientX = isTouch ? event.touches[0].clientX : event.clientX;
    const deltaX = touchStartX.current - clientX;
    touchDelta.current = deltaX;

    if (main.current) {
      main.current.style.left = -deltaX+"px";
    }

    if(left.current) {
      let opacityValue = 1;
      let delta = deltaX*1.5+window.innerWidth;
      if(delta<0) {
        opacityValue = 1;
      } else {
        opacityValue = Math.max(0.2, 1 - delta / window.innerWidth);
      }
      left.current.style.opacity = opacityValue;
    }
    if(center.current) {
      let opacityValue = 1;
      if(deltaX<0) {
        opacityValue = Math.max(0, 1 + deltaX / window.innerWidth);
      } else {
        opacityValue = Math.max(0, 1 - deltaX / window.innerWidth);
      }
      center.current.style.opacity = opacityValue;
    }
    if(right.current) {
      let opacityValue = 1;
      let delta = deltaX*1.5-window.innerWidth;
      if(delta<0) {
        opacityValue = Math.max(0.2, 1 + delta / window.innerWidth);
      } else {
        opacityValue = 1;
      }
      right.current.style.opacity = opacityValue;
    }
  };

  const handleMouseEnd = (main,left,center,right) => {
    if (!touchDelta.current) return;

    if (main.current) {
      main.current.style.left = "0px";
    }
    if(left.current) {
      left.current.style.opacity = 0.2;
    }
    if(center.current) {
      center.current.style.opacity = 1.0;
    }
    if(right.current) {
      right.current.style.opacity = 0.2;
    }
    var area = window.innerWidth;
    if(window.innerHeight<area) {
      area = window.innerHeight;
    }
    if (Math.abs(touchDelta.current) > area/3) {
      if (touchDelta.current > 0) {
        goToNext();
      } else {
        goToPrev();
      }
    }
    touchStartX.current = null;
    touchDelta.current = null;
  };

  const scrollThumbnails = (index) => {
    if (thumbnailsRef.current) {
      const thumbnailsContainer = thumbnailsRef.current;
      const selectedThumbnail = thumbnailsContainer.children[index];
      if (selectedThumbnail) {
        const containerWidth = thumbnailsContainer.clientWidth;
        const containerHeight = thumbnailsContainer.clientHeight;
        if (containerWidth>containerHeight) {
          const thumbnailWidth = selectedThumbnail.clientWidth;
          const scrollOffset = selectedThumbnail.offsetLeft - (containerWidth / 2) + (thumbnailWidth / 2);
          thumbnailsContainer.scrollTo({ left: scrollOffset-thumbnailsContainer.offsetLeft, behavior: "smooth" });
        } else {
          const thumbnailHeight = selectedThumbnail.clientHeight;
          const scrollOffset = selectedThumbnail.offsetTop - (containerHeight / 2) + (thumbnailHeight / 2);
          thumbnailsContainer.scrollTo({ top: scrollOffset-thumbnailsContainer.offsetTop, behavior: "smooth" });
        }
      } 
    }
  };

  const getImage = (id,type) => {
    id = images[id];
    if(mode==="edit") {
      if (typeof id === 'number' && !isNaN(id)) {
        return config.photos[module]+module+"/"+name+"/"+type+"_"+id+".jpg?v=" +timestamp;
      }
    }
    return id;
  };

  const prevIndex = (currentIndex - 1 + images.length) % images.length;
  const nextIndex = (currentIndex + 1 ) % images.length;

  return (
    <div className="gallery-container">
      <div className="gallery-container-main">
          <div
            className="gallery-main"
            onMouseDown={handleMouseStart}
            onMouseMove={(event) => handleMouseMove(event,imgMainRef,imgLeftRef,imgCenterRef,imgRightRef)}
            onTouchStart={handleMouseStart}
            onTouchMove={(event) => handleMouseMove(event,imgMainRef,imgLeftRef,imgCenterRef,imgRightRef)}
            onTouchEnd={() => handleMouseEnd(imgMainRef,imgLeftRef,imgCenterRef,imgRightRef)}
            ref={imgMainRef}
          >
              <div className="gallery-image-container-left">
                <div className="gallery-image" ref={imgLeftRef} >
                  <Image src={getImage(prevIndex,"normal")} draggable="false" />
                </div>
              </div>
              <div className="gallery-image-container-center">
                <div className="gallery-image" ref={imgCenterRef} >
                  <Image src={getImage(currentIndex,"normal")} draggable="false" className="gallery-image-img" />
                </div>
              </div>
              <div className="gallery-image-container-right">
                <div className="gallery-image" ref={imgRightRef} >
                  <Image src={getImage(nextIndex,"normal")} draggable="false" />
                </div>
              </div>
        </div>
      </div>
      <div className="gallery-container-thumbnail">
        <div className="gallery-thumbnails" ref={thumbnailsRef}>
          {images.map((image, index) => (
            <div
              key={"gallery-thumbnails-"+index}
              onClick={() => {
                setCurrentIndex(index);
                scrollThumbnails(index);
              }}
            >
              <Image
                key={"gallery-thumbnails-"+index}
                src={getImage(index,"icon")}
                smallLoading={true}
                className={currentIndex === index ? "gallery-thumbnails-img-active" : "gallery-thumbnails-img"}
                draggable="false"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;